<!-- ============================================================
     HR ADMIN — HUMAN RESOURCES MANAGEMENT SYSTEM
     ============================================================ -->
<div class="hr-page">

  @if (toast_msg()) {
    <div class="hr-toast alert alert-success d-flex align-items-center gap-2 shadow">
      <i class="bi bi-check-circle-fill fs-5"></i><strong>{{ toast_msg() }}</strong>
    </div>
  }

  <!-- ══ REJECT LEAVE MODAL ═══════════════════════════════════ -->
  @if (show_reject_modal()) {
    <div class="hr-overlay" (click)="show_reject_modal.set(null)">
      <div class="hr-modal-sm" (click)="$event.stopPropagation()">
        <div class="hmh hmh-red"><div class="hmh-ic"><i class="bi bi-x-circle-fill"></i></div><h5 class="hmh-title">Reject Leave</h5><button class="hmh-close" (click)="show_reject_modal.set(null)"><i class="bi bi-x-lg"></i></button></div>
        <div class="hmb p-4">
          <label class="form-label fw-semibold">Rejection Reason <span class="req">*</span></label>
          <textarea class="form-control" [(ngModel)]="reject_reason" rows="3" placeholder="Reason for rejection…"></textarea>
          @if (!reject_reason.trim()) { <div class="text-danger small mt-1">Reason is required.</div> }
        </div>
        <div class="hmf"><button class="btn btn-outline-secondary" (click)="show_reject_modal.set(null)">Cancel</button><button class="btn btn-danger px-4" (click)="confirm_reject()" [disabled]="!reject_reason.trim()"><i class="bi bi-x-circle-fill me-1"></i>Reject</button></div>
      </div>
    </div>
  }

  <!-- ══ EMPLOYEE DETAIL MODAL ════════════════════════════════ -->
  @if (show_emp_detail()) {
    @let ed = show_emp_detail()!;
    <div class="hr-overlay" (click)="show_emp_detail.set(null)">
      <div class="hr-modal-lg" (click)="$event.stopPropagation()">
        <div class="hmh" [style.background]="'linear-gradient(135deg,'+get_st_color(ed.staff_type)+', #2d6a9f)'">
          <div class="emp-av-lg">{{ get_initials(get_full_name(ed)) }}</div>
          <div><h5 class="hmh-title">{{ get_full_name(ed) }}</h5><p class="hmh-sub">{{ ed.emp_code }} · {{ ed.designation }}</p></div>
          <span class="{{ get_emp_st_class(ed.status) }} ms-auto me-3">{{ ed.status }}</span>
          <button class="hmh-close" (click)="show_emp_detail.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hmb p-4">
          <div class="row g-3">
            <div class="col-md-3"><div class="kv-item"><span>Department</span><span>{{ ed.department }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Staff Type</span><span>{{ ed.staff_type }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Employment</span><span>{{ ed.employment }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Gender</span><span>{{ ed.gender }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Date of Birth</span><span>{{ fmt_date(ed.dob) }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Age</span><span>{{ calc_age(ed.dob) }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Date of Joining</span><span>{{ fmt_date(ed.doj) }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Experience</span><span>{{ ed.experience != null ? ed.experience + ' yrs' : calc_yoe(ed.doj) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Email</span><span>{{ ed.email }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Mobile</span><span>{{ ed.mobile }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Basic Salary</span><span class="text-success fw-bold">{{ fmt_curr(ed.basic_salary) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>PAN</span><span class="font-mono">{{ ed.pan_number || '—' }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Aadhaar</span><span class="font-mono">{{ ed.aadhaar_number || '—' }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>UAN</span><span class="font-mono">{{ ed.uan_number || '—' }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Blood Group</span><span>{{ ed.blood_group || '—' }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Active</span><span>{{ ed.is_active ? 'Yes' : 'No' }}</span></div></div>
            @if (ed.dol) {
              <div class="col-md-4"><div class="kv-item"><span>Date of Leaving</span><span>{{ fmt_date(ed.dol) }}</span></div></div>
            }
            @if (ed.subjects.length) {
              <div class="col-12"><div class="kv-item"><span>Subjects</span><span>{{ ed.subjects.join(', ') }}</span></div></div>
            }
            @if (ed.qualifications.length) {
              <div class="col-12">
                <div class="kv-item">
                  <span>Qualifications</span>
                  <span>
                    @for (q of ed.qualifications; track $index) {
                      <div>{{ q.degree || '—' }}{{ q.subject ? ' · ' + q.subject : '' }}{{ q.institution ? ' · ' + q.institution : '' }}{{ q.year_of_passing ? ' · ' + q.year_of_passing : '' }}{{ q.percentage != null ? ' · ' + q.percentage + '%' : '' }}</div>
                    }
                  </span>
                </div>
              </div>
            }
            @if (ed.documents.length) {
              <div class="col-12">
                <div class="kv-item">
                  <span>Documents</span>
                  <span>
                    @for (d of ed.documents; track $index) {
                      <div>{{ d.name }}{{ d.file_name ? ' — ' + d.file_name : '' }}</div>
                    }
                  </span>
                </div>
              </div>
            }
            <div class="col-12"><div class="kv-item"><span>Address</span><span>{{ ed.address || '—' }}{{ ed.city ? ', ' + ed.city : '' }}{{ ed.state ? ', ' + ed.state : '' }}{{ ed.pin_code ? ' – ' + ed.pin_code : '' }}</span></div></div>
            @if (ed.remarks) {
              <div class="col-12"><div class="kv-item"><span>Remarks</span><span>{{ ed.remarks }}</span></div></div>
            }
          </div>
        </div>
        <!-- <div class="hmf">
          <button class="btn btn-outline-secondary" (click)="show_emp_detail.set(null)">Close</button>
          <button class="btn hr-btn-primary" (click)="show_emp_detail.set(null); open_emp_form(ed)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
        </div> -->
      </div>
    </div>
  }

  <!-- ══ EMPLOYEE FORM MODAL ══════════════════════════════════ -->
  <!-- @if (show_emp_modal()) {
    <div class="hr-overlay" (click)="show_emp_modal.set(false)">
      <div class="hr-modal-xl" (click)="$event.stopPropagation()">
        <div class="hmh"><div class="hmh-ic"><i class="bi bi-person-fill"></i></div><h5 class="hmh-title">{{ editing_id() ? 'Edit Employee' : 'Add Employee' }}</h5><button class="hmh-close" (click)="show_emp_modal.set(false)"><i class="bi bi-x-lg"></i></button></div>
        <div class="hmb p-4">
          <div class="form-section-hdr mb-3">Personal Details</div>
          <div class="row g-3 mb-3">
            <div class="col-md-2"><label class="form-label fw-semibold">Emp Code</label><input class="form-control font-mono" [(ngModel)]="emp_form.emp_code" maxlength="20" placeholder="TCH-2026-0100" [readonly]="!!editing_id()"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">First Name <span class="req">*</span></label><input class="form-control" [(ngModel)]="emp_form.first_name" maxlength="50" [class.is-invalid]="emp_submitted && !emp_form.first_name?.trim()"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Last Name <span class="req">*</span></label><input class="form-control" [(ngModel)]="emp_form.last_name" maxlength="50" [class.is-invalid]="emp_submitted && !emp_form.last_name?.trim()"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Gender</label><select class="form-select" [(ngModel)]="emp_form.gender">@for (g of gender_opts; track g) { <option [value]="g">{{ g }}</option> }</select></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Date of Birth</label><input type="date" class="form-control" [(ngModel)]="emp_form.dob"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Blood Group</label><select class="form-select" [(ngModel)]="emp_form.blood_group"><option value="">—</option>@for (b of blood_group_opts; track b) { <option [value]="b">{{ b }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Mobile</label><input type="tel" class="form-control" [(ngModel)]="emp_form.mobile" maxlength="15"></div>
            <div class="col-md-4"><label class="form-label fw-semibold">Email</label><input type="email" class="form-control" [(ngModel)]="emp_form.email" maxlength="100"></div>
            <div class="col-md-5"><label class="form-label fw-semibold">Address</label><input class="form-control" [(ngModel)]="emp_form.address" maxlength="200"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">City</label><input class="form-control" [(ngModel)]="emp_form.city" maxlength="60"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">State</label><select class="form-select" [(ngModel)]="emp_form.state"><option value="">—</option>@for (s of state_opts; track s) { <option [value]="s">{{ s }}</option> }</select></div>
            <div class="col-md-2"><label class="form-label fw-semibold">PIN</label><input class="form-control" [(ngModel)]="emp_form.pin_code" maxlength="10"></div>
          </div>
          <div class="form-section-hdr mb-3">Employment Details</div>
          <div class="row g-3 mb-3">
            <div class="col-md-3"><label class="form-label fw-semibold">Staff Type</label><select class="form-select" [(ngModel)]="emp_form.staff_type" (ngModelChange)="on_staff_type_change()">@for (t of staff_type_opts; track t) { <option [value]="t">{{ t }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Department</label><select class="form-select" [(ngModel)]="emp_form.department"><option value="">Select…</option>@for (d of dept_opts; track d) { <option [value]="d">{{ d }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Designation</label><select class="form-select" [(ngModel)]="emp_form.designation"><option value="">Select…</option>@for (d of emp_designations; track d) { <option [value]="d">{{ d }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Employment</label><select class="form-select" [(ngModel)]="emp_form.employment">@for (t of emp_type_opts; track t) { <option [value]="t">{{ t }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Date of Joining</label><input type="date" class="form-control" name="emp_doj" [(ngModel)]="emp_form.doj"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Date of Leaving</label><input type="date" class="form-control" name="emp_dol" [(ngModel)]="emp_form.dol"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Experience (yrs)</label><input type="number" class="form-control" name="emp_experience" [(ngModel)]="emp_form.experience" min="0"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Basic Salary (₹)</label><div class="input-group"><span class="input-group-text">₹</span><input type="number" class="form-control" name="emp_basic_salary" [(ngModel)]="emp_form.basic_salary" min="0"></div></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Status</label><select class="form-select" name="emp_status" [(ngModel)]="emp_form.status" (ngModelChange)="on_emp_status_change()">@for (s of emp_status_opts; track s) { <option [value]="s">{{ s }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">PAN Number</label><input class="form-control font-mono" name="emp_pan" [(ngModel)]="emp_form.pan_number" maxlength="10" placeholder="ABCDE1234F"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Aadhaar</label><input class="form-control font-mono" name="emp_aadhaar" [(ngModel)]="emp_form.aadhaar_number" maxlength="12"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">UAN Number</label><input class="form-control font-mono" name="emp_uan" [(ngModel)]="emp_form.uan_number" maxlength="12"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Active</label>
              <select class="form-select" name="emp_is_active" [ngModel]="emp_form.is_active === false ? 'no' : 'yes'" (ngModelChange)="emp_form.is_active = $event === 'yes'">
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div class="col-12"><label class="form-label fw-semibold">Subjects</label><input class="form-control" name="emp_subjects" [ngModel]="subjects_text" (ngModelChange)="subjects_text = $event" maxlength="200" placeholder="Comma-separated, e.g. Physics, Chemistry"></div>
            <div class="col-12"><label class="form-label fw-semibold">Remarks</label><input class="form-control" name="emp_remarks" [(ngModel)]="emp_form.remarks" maxlength="200"></div>
          </div>
          @if (has_emp_errors()) {
            <div class="alert alert-danger d-flex gap-2 align-items-center mt-3 py-2"><i class="bi bi-exclamation-triangle-fill"></i>First Name and Last Name are required.</div>
          }
        </div>
        <div class="hmf"><button class="btn btn-outline-secondary px-4" (click)="show_emp_modal.set(false)">Cancel</button><button class="btn hr-btn-primary px-5" (click)="save_employee()"><i class="bi bi-check-circle-fill me-1"></i>Save Employee</button></div>
      </div>
    </div>
  } -->

  <!-- ══ LEAVE REQUEST MODAL ══════════════════════════════════ -->
  @if (show_leave_modal()) {
    <div class="hr-overlay" (click)="show_leave_modal.set(false)">
      <div class="hr-modal" (click)="$event.stopPropagation()">
        <div class="hmh hmh-green"><div class="hmh-ic"><i class="bi bi-calendar-plus-fill"></i></div><h5 class="hmh-title">Leave Application</h5><button class="hmh-close" (click)="show_leave_modal.set(false)"><i class="bi bi-x-lg"></i></button></div>
        <div class="hmb p-4">
          <div class="row g-3">
            <div class="col-md-6"><label class="form-label fw-semibold">Employee <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="leave_form.emp_code" [class.is-invalid]="leave_submitted && !leave_form.emp_code">
                <option value="">Select employee…</option>
                @for (e of employees(); track e.emp_code) { @if (e.status==='Active') { <option [value]="e.emp_code">{{ e.emp_code }} – {{ get_full_name(e) }}</option> } }
              </select></div>
            <div class="col-md-6"><label class="form-label fw-semibold">Leave Type</label>
              <select class="form-select" [(ngModel)]="leave_form.leave_type">
                @for (t of leave_type_opts; track t) { <option [value]="t" class="text-capitalize">{{ t.charAt(0).toUpperCase() + t.slice(1) }} Leave</option> }
              </select></div>
            <div class="col-md-5"><label class="form-label fw-semibold">From Date</label><input type="date" class="form-control" [(ngModel)]="leave_form.from_date" (change)="calc_leave_days()"></div>
            <div class="col-md-5"><label class="form-label fw-semibold">To Date</label><input type="date" class="form-control" [(ngModel)]="leave_form.to_date" (change)="calc_leave_days()"></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Days</label><input type="number" class="form-control" [(ngModel)]="leave_form.days" min="1" readonly></div>
            <div class="col-12"><label class="form-label fw-semibold">Reason <span class="req">*</span></label><textarea class="form-control" [(ngModel)]="leave_form.reason" rows="3" maxlength="300" [class.is-invalid]="leave_submitted && !leave_form.reason?.trim()"></textarea></div>
          </div>
        </div>
        <div class="hmf"><button class="btn btn-outline-secondary px-4" (click)="show_leave_modal.set(false)">Cancel</button><button class="btn hr-btn-primary px-5" (click)="save_leave()"><i class="bi bi-check-circle-fill me-1"></i>Submit</button></div>
      </div>
    </div>
  }

  <!-- ══ JOB FORM MODAL ══════════════════════════════════════ -->
  @if (show_job_modal()) {
    <div class="hr-overlay" (click)="show_job_modal.set(false)">
      <div class="hr-modal-lg" (click)="$event.stopPropagation()">
        <div class="hmh hmh-amber"><div class="hmh-ic"><i class="bi bi-briefcase-fill"></i></div><h5 class="hmh-title">{{ editing_job_id() ? 'Edit Job Opening' : 'Create Job Opening' }}</h5><button class="hmh-close" (click)="show_job_modal.set(false)"><i class="bi bi-x-lg"></i></button></div>
        <div class="hmb p-4">
          <div class="row g-3">
            @if (editing_job_id()) {
              <div class="col-md-3"><label class="form-label fw-semibold">Job Code</label><input class="form-control font-mono" [(ngModel)]="job_form.job_code" readonly></div>
            }
            <div class="col-md-6"><label class="form-label fw-semibold">Job Title <span class="req">*</span></label><input class="form-control" [(ngModel)]="job_form.title" maxlength="100" [class.is-invalid]="job_submitted && !job_form.title?.trim()"></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Department <span class="req">*</span></label><select class="form-select" [(ngModel)]="job_form.department" [class.is-invalid]="job_submitted && !job_form.department?.trim()"><option value="">Select…</option>@for (d of dept_opts; track d) { <option [value]="d">{{ d }}</option> }</select></div>
            <div class="col-md-3"><label class="form-label fw-semibold">Employment Type</label><select class="form-select" [(ngModel)]="job_form.emp_type">@for (t of job_emp_type_opts; track t) { <option [value]="t">{{ job_type_labels[t] }}</option> }</select></div>
            <div class="col-md-2"><label class="form-label fw-semibold">Positions</label><input type="number" class="form-control" [(ngModel)]="job_form.positions" min="1"></div>
            @if (editing_job_id()) {
              <div class="col-md-2"><label class="form-label fw-semibold">Filled</label><input type="number" class="form-control" [(ngModel)]="job_form.filled" min="0"></div>
            }
            <div class="col-md-3"><label class="form-label fw-semibold">Status</label>
              <select class="form-select" [(ngModel)]="job_form.status">
                @for (s of job_status_opts; track s) { <option [value]="s">{{ job_status_labels[s] }}</option> }
              </select>
            </div>
            <div class="col-md-4"><label class="form-label fw-semibold">Closing Date</label><input type="date" class="form-control" [(ngModel)]="job_form.closing_date"></div>
            <div class="col-12"><label class="form-label fw-semibold">Description</label><textarea class="form-control" [(ngModel)]="job_form.description" rows="3" maxlength="2000"></textarea></div>
            <div class="col-12"><label class="form-label fw-semibold">Requirements</label><textarea class="form-control" [(ngModel)]="job_form.requirements" rows="3" maxlength="2000"></textarea></div>
          </div>
        </div>
        <div class="hmf">
          <button class="btn btn-outline-secondary px-4" (click)="show_job_modal.set(false)">Cancel</button>
          <button class="btn hr-btn-primary px-5" (click)="save_job()"><i class="bi bi-check-circle-fill me-1"></i>{{ editing_job_id() ? 'Save Changes' : 'Create Opening' }}</button>
        </div>
      </div>
    </div>
  }

  <!-- ══ JOB POST DETAILS ════════════════════════════════════ -->
  @if (show_job_detail()) {
    @let jd = show_job_detail()!;
    <div class="hr-overlay" (click)="show_job_detail.set(null)">
      <div class="hr-modal-lg" (click)="$event.stopPropagation()">
        <div class="hmh hmh-amber">
          <div class="hmh-ic"><i class="bi bi-briefcase-fill"></i></div>
          <div>
            <h5 class="hmh-title">{{ jd.title }}</h5>
            <p class="hmh-sub">{{ jd.job_code }} · {{ jd.department }}</p>
          </div>
          <span class="{{ get_job_st_class(jd.status) }} ms-auto me-3">{{ jd.status.replace('_',' ') }}</span>
          <button class="hmh-close" (click)="show_job_detail.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hmb p-4">
          <div class="row g-3 mb-3">
            <div class="col-md-3"><div class="kv-item"><span>Employment</span><span>{{ job_type_labels[jd.emp_type] }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Positions</span><span>{{ jd.filled }} / {{ jd.positions }} filled</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Posted</span><span>{{ fmt_date(jd.posted_date) }}</span></div></div>
            <div class="col-md-3"><div class="kv-item"><span>Closes</span><span>{{ fmt_date(jd.closing_date) }}</span></div></div>
          </div>
          <div class="form-section-hdr mb-2">Role description</div>
          <p class="job-detail-body">{{ jd.description || 'No description provided.' }}</p>
          <div class="form-section-hdr mb-2 mt-3">Requirements</div>
          <p class="job-detail-body">{{ jd.requirements || 'No requirements listed.' }}</p>
          <div class="form-section-hdr mb-2 mt-3">Share this posting</div>
          <p class="small text-muted mb-2">Candidates can open this link to read the full job details before they apply. Copy it to career boards or social sites.</p>
          <div class="input-group mb-3">
            <input class="form-control font-mono" [value]="job_share_url(jd)" readonly>
            <button type="button" class="btn hr-btn-primary" (click)="copy_job_link(jd)"><i class="bi bi-clipboard-check me-1"></i>Copy link</button>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <a class="btn btn-sm btn-outline-success" [href]="social_share_url(jd, 'whatsapp')" target="_blank" rel="noopener"><i class="bi bi-whatsapp me-1"></i>WhatsApp</a>
            <a class="btn btn-sm btn-outline-primary" [href]="social_share_url(jd, 'linkedin')" target="_blank" rel="noopener"><i class="bi bi-linkedin me-1"></i>LinkedIn</a>
            <a class="btn btn-sm btn-outline-dark" [href]="social_share_url(jd, 'x')" target="_blank" rel="noopener"><i class="bi bi-twitter-x me-1"></i>X</a>
            <a class="btn btn-sm btn-outline-secondary" [href]="social_share_url(jd, 'email')"><i class="bi bi-envelope me-1"></i>Email</a>

            <!-- <button class="btn btn-sm btn-outline-primary ms-auto" (click)="open_public_job(jd)"><i class="bi bi-box-arrow-up-right me-1"></i>Open candidate view</button> -->
             <a href="/careers/{{jd.job_code}}" class="ms-auto" target="_blank"><i class="bi bi-box-arrow-up-right me-1"></i>Open candidate view</a>
          </div>
        </div>
        <!-- <div class="hmf">
          <button class="btn btn-outline-secondary" (click)="show_job_detail.set(null)">Close</button>
          <button class="btn btn-outline-primary" (click)="open_public_job(jd)"><i class="bi bi-box-arrow-up-right me-1"></i>Open candidate view</button>
          <button class="btn hr-btn-primary" (click)="copy_job_link(jd)"><i class="bi bi-link-45deg me-1"></i>Copy job link</button>
        </div> -->
      </div>
    </div>
  }

  <!-- ══ PAYSLIP MODAL ════════════════════════════════════════ -->
  @if (show_payslip()) {
    @let ps = show_payslip()!;
    <div class="hr-overlay" (click)="show_payslip.set(null)">
      <div class="hr-modal-lg payslip-modal" (click)="$event.stopPropagation()">
        <div class="payslip-header no-print-close">
          <div class="psh-left"><div class="psh-logo"><i class="bi bi-building-fill"></i></div><div><div class="psh-school">EduSmart International School</div><div class="psh-addr">123, Education Road, Mumbai – 400001 | payroll&#64;school.in</div></div></div>
          <div class="psh-right"><div class="psh-title">SALARY SLIP</div><div class="psh-month">{{ ps.month }}</div></div>
          <button class="hmh-close no-print" (click)="show_payslip.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hmb p-4">
          <div class="ps-emp-row">
            <div class="ps-emp-info">
              <div class="row g-2">
                <div class="col-6"><div class="kv-item-sm"><span>Employee ID</span><span class="font-mono">{{ ps.emp_code }}</span></div></div>
                <div class="col-6"><div class="kv-item-sm"><span>Employee Name</span><span class="fw-semibold">{{ ps.emp_name }}</span></div></div>
                <div class="col-6"><div class="kv-item-sm"><span>Designation</span><span>{{ dataService.getDesiName(ps.designation) }}</span></div></div>
                <div class="col-6"><div class="kv-item-sm"><span>Department</span><span>{{ dataService.getDeptName(ps.department) }}</span></div></div>
                <div class="col-6"><div class="kv-item-sm"><span>Working Days</span><span>{{ ps.working_days }}</span></div></div>
                <div class="col-6"><div class="kv-item-sm"><span>Present Days</span><span class="text-success fw-semibold">{{ ps.present_days }}</span></div></div>
              </div>
            </div>
          </div>
          <div class="row g-3 mt-2">
            <div class="col-md-6">
              <div class="ps-section-hdr earnings-hdr"><i class="bi bi-plus-circle-fill me-2"></i>Earnings</div>
              <table class="ps-table">
                <tbody>
                  <tr><td>Basic Salary</td><td class="text-end">{{ fmt_curr(ps.basic_salary) }}</td></tr>
                  <tr><td>House Rent Allowance (HRA)</td><td class="text-end">{{ fmt_curr(ps.hra) }}</td></tr>
                  <tr><td>Dearness Allowance (DA)</td><td class="text-end">{{ fmt_curr(ps.da) }}</td></tr>
                  <tr><td>Special Allowance</td><td class="text-end">{{ fmt_curr(ps.special_allowance) }}</td></tr>
                  <tr class="ps-total-row"><td class="fw-bold">Gross Earnings</td><td class="text-end fw-bold text-success">{{ fmt_curr(ps.gross_salary) }}</td></tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <div class="ps-section-hdr deductions-hdr"><i class="bi bi-dash-circle-fill me-2"></i>Deductions</div>
              <table class="ps-table">
                <tbody>
                  <tr><td>Provident Fund (12% of Basic)</td><td class="text-end text-danger">–{{ fmt_curr(ps.pf_deduction) }}</td></tr>
                  <tr><td>Professional Tax</td><td class="text-end text-danger">–{{ fmt_curr(ps.professional_tax) }}</td></tr>
                  <tr><td>Income Tax (TDS)</td><td class="text-end text-danger">–{{ fmt_curr(ps.tds_deduction) }}</td></tr>
                  @if (ps.other_deductions) { <tr><td>Other Deductions</td><td class="text-end text-danger">–{{ fmt_curr(ps.other_deductions) }}</td></tr> }
                  <tr class="ps-total-row"><td class="fw-bold">Total Deductions</td><td class="text-end fw-bold text-danger">–{{ fmt_curr(ps.pf_deduction+ps.professional_tax+ps.tds_deduction+ps.other_deductions) }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="ps-net-row mt-3">
            <div class="psn-label">NET SALARY PAYABLE</div>
            <div class="psn-amount">{{ fmt_curr(ps.net_salary) }}</div>
            <div class="psn-mode">Payment Mode: {{ ps.payment_mode.replace('_',' ').toUpperCase() }}</div>
          </div>
          <div class="ps-sig-row mt-4">
            <div class="ps-sig"><div class="sig-line"></div><div class="sig-lbl">Accounts Manager</div></div>
            <div class="ps-sig"><div class="sig-line"></div><div class="sig-lbl">HR Manager</div></div>
            <div class="ps-sig"><div class="sig-line"></div><div class="sig-lbl">Employee Signature</div></div>
          </div>
          <p class="text-muted small text-center mt-2 mb-0">This is a computer-generated payslip and does not require a physical signature.</p>
        </div>
        <div class="hmf no-print"><button class="btn btn-outline-secondary" (click)="show_payslip.set(null)">Close</button><button class="btn hr-btn-primary" (click)="print_payslip()"><i class="bi bi-printer-fill me-1"></i>Print Payslip</button></div>
      </div>
    </div>
  }

  <!-- ══ MARK ATTENDANCE MODAL ════════════════════════════════ -->
  @if (show_att_modal()) {
    <div class="hr-overlay" (click)="show_att_modal.set(false)">
      <div class="hr-modal" (click)="$event.stopPropagation()">
        <div class="hmh hmh-green">
          <div class="hmh-ic"><i class="bi bi-person-check-fill"></i></div>
          <h5 class="hmh-title">{{ att_form.id ? 'Edit Attendance' : 'Mark Attendance' }}</h5>
          <button class="hmh-close" (click)="show_att_modal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="hmb p-4">
          <div class="row g-3">
            <div class="col-md-8">
              <label class="form-label fw-semibold">Employee <span class="req">*</span></label>
              <select class="form-select" name="att_emp" [(ngModel)]="att_form.emp_code"
                (ngModelChange)="on_att_emp_change()"
                [class.is-invalid]="att_submitted && !att_form.emp_code">
                <option value="">Select employee…</option>
                @for (e of employees(); track e.emp_code) {
                  @if (e.is_active || e.status === 'Active' || e.status === 'On Leave') {
                    <option [value]="e.emp_code">{{ e.emp_code }} – {{ get_full_name(e) }}</option>
                  }
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Date <span class="req">*</span></label>
              <input type="date" class="form-control" name="att_form_date" [(ngModel)]="att_form.date"
                [class.is-invalid]="att_submitted && !att_form.date">
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Status</label>
              <select class="form-select" name="att_form_status" [(ngModel)]="att_form.status" (ngModelChange)="on_att_status_change()">
                @for (s of att_status_opts; track s) { <option [value]="s">{{ s.replace('_',' ') }}</option> }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Total Hours</label>
              <input class="form-control fw-semibold" [value]="fmt_hours(att_form.working_hours)" readonly>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">In Time <span class="req">*</span></label>
              <input type="time" class="form-control" name="att_in_time" [(ngModel)]="att_form.check_in"
                (ngModelChange)="on_att_time_change()"
                [disabled]="att_times_disabled(att_form.status ?? 'present')"
                [class.is-invalid]="att_submitted && !att_times_disabled(att_form.status ?? 'present') && !att_form.check_in">
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Out Time</label>
              <input type="time" class="form-control" name="att_out_time" [(ngModel)]="att_form.check_out"
                (ngModelChange)="on_att_time_change()"
                [disabled]="att_times_disabled(att_form.status ?? 'present')">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Remarks</label>
              <input class="form-control" name="att_remarks" [(ngModel)]="att_form.remarks" maxlength="200" placeholder="Optional note…">
            </div>
          </div>
          @if (att_submitted && (!att_form.emp_code || !att_form.date || (!att_times_disabled(att_form.status ?? 'present') && !att_form.check_in))) {
            <div class="alert alert-danger d-flex gap-2 align-items-center mt-3 py-2"><i class="bi bi-exclamation-triangle-fill"></i>Employee, date and in-time are required.</div>
          }
        </div>
        <div class="hmf">
          <button class="btn btn-outline-secondary" (click)="show_att_modal.set(false)">Cancel</button>
          <button class="btn hr-btn-primary px-4" (click)="save_attendance()"><i class="bi bi-check-circle-fill me-1"></i>Save Attendance</button>
        </div>
      </div>
    </div>
  }

  <!-- ════════════ PAGE HEADER ════════════════════════════════ -->
  <div class="hr-ph mb-4">
    <div class="d-flex align-items-center gap-3">
      <div class="hr-logo"><i class="bi bi-people-fill"></i></div>
      <div><h1 class="hr-title">HR Admin</h1><p class="hr-subtitle">Employee management · Leaves · Attendance · Payroll · Recruitment</p></div>
    </div>
    <div class="d-flex gap-2 flex-wrap">
      <!-- @if (active_tab() === 'employees')   { <button class="btn hr-btn-primary btn-sm" (click)="open_emp_form()"><i class="bi bi-person-plus-fill me-1"></i>Add Employee</button> } -->
      @if (active_tab() === 'leaves')      { <button class="btn hr-btn-primary btn-sm" (click)="open_leave_form()"><i class="bi bi-calendar-plus-fill me-1"></i>Apply Leave</button> }
      @if (active_tab() === 'attendance')  { <button class="btn hr-btn-primary btn-sm" (click)="open_att_form()"><i class="bi bi-person-check-fill me-1"></i>Mark Attendance</button> }
      @if (active_tab() === 'recruitment') { <button class="btn hr-btn-primary btn-sm" (click)="open_job_form()"><i class="bi bi-briefcase-fill me-1"></i>Post Job</button> }
    </div>
  </div>

  <!-- TABS -->
  <div class="hr-tabs mb-4">
    @for (t of [{k:'dashboard',l:'Dashboard',ic:'bi-grid-fill'},{k:'employees',l:'Employees',ic:'bi-people-fill'},{k:'leaves',l:'Leaves',ic:'bi-calendar-event-fill'},{k:'attendance',l:'Attendance',ic:'bi-person-check-fill'},{k:'payroll',l:'Payroll',ic:'bi-cash-stack'},{k:'recruitment',l:'Recruitment',ic:'bi-briefcase-fill'}]; track t.k) {
      <button class="hrtab" [class.active]="active_tab() === t.k" (click)="active_tab.set($any(t.k))">
        <i class="bi {{ t.ic }} me-1"></i>{{ t.l }}
        @if (t.k === 'leaves' && dash_stats().pending_leaves > 0) { <span class="hrtab-badge">{{ dash_stats().pending_leaves }}</span> }
      </button>
    }
  </div>

  <!-- ════════════ DASHBOARD ══════════════════════════════════ -->
  @if (active_tab() === 'dashboard') {
    <div class="hr-kpi-row mb-4">
      <div class="kpi-card kpi-total d-flex flex-column gap-0">
        <div class="w-100 d-flex gap-3">
          <div class="kpi-ic"><i class="bi bi-people-fill"></i></div>
          <div>
            <div class="kpi-val">{{ dash_stats().total }}</div>
            <div class="kpi-lbl">Total Staff</div>
          </div>
        </div>
        <!-- <div class="kpi-sub">
          <span class="badge-t bg-green">{{ dash_stats().teaching }} teaching</span>
        </div> -->
      </div>
      <div class="kpi-card kpi-present d-flex flex-column gap-0">
        <div class="w-100 d-flex gap-3">
          <div class="kpi-ic"><i class="bi bi-person-check-fill"></i></div>
          <div>
            <div class="kpi-val">{{ dash_stats().present_today }}</div>
            <div class="kpi-lbl">Present Today</div>
          </div>
        </div>
        <!-- <div class="kpi-sub">
          <span class="text-danger small">{{ dash_stats().absent_today }} absent</span>
        </div> -->
      </div>
      <div class="kpi-card kpi-leave d-flex flex-column gap-0">
        <div class="w-100 d-flex gap-3">
          <div class="kpi-ic"><i class="bi bi-calendar-x-fill"></i></div>
          <div>
            <div class="kpi-val {{ dash_stats().pending_leaves > 0 ? 'text-warning' : '' }}">{{ dash_stats().pending_leaves }}</div>
            <div class="kpi-lbl">Pending Leaves</div>
          </div>
        </div>
      </div>
      <div class="kpi-card kpi-recruit d-flex flex-column gap-0">
        <div class="w-100 d-flex gap-3">
          <div class="kpi-ic"><i class="bi bi-briefcase-fill"></i></div>
          <div>
            <div class="kpi-val">{{ dash_stats().open_positions }}</div>
            <div class="kpi-lbl">Open Positions</div>
          </div>
        </div>
      </div>
      <div class="kpi-card kpi-payroll d-flex flex-column gap-0">
        <div class="w-100 d-flex gap-3">
          <div class="kpi-ic"><i class="bi bi-cash-stack"></i></div>
          <div>
            <div class="kpi-val">{{ fmt_short(dash_stats().monthly_bill) }}</div>
            <div class="kpi-lbl">Monthly Salary Bill</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4 mb-4">
      <!-- Dept headcount chart -->
      <div class="col-lg-6">
        <div class="hr-card h-100">
          <div class="hcard-hdr"><i class="bi bi-building-fill me-2"></i>Department-wise Headcount</div>
          <div class="hcard-body">
            @for (d of dept_stats(); track d.dept) {
              <div class="dept-bar-row">
                <div class="dbr-dept">{{ dataService.getDeptName(d.dept) }}</div>
                <div class="dbr-bar-wrap">
                  <div class="dbr-bar" [style.width]="dept_bar_w(d.count)">{{ d.count }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Staff breakdown + leave summary -->
      <div class="col-lg-6 d-flex flex-column gap-3">
        <div class="hr-card">
          <div class="hcard-hdr"><i class="bi bi-pie-chart-fill me-2"></i>Staff Composition</div>
          <div class="hcard-body">
            <div class="composition-row">
              @for (t of staff_composition(); track t.type) {
                <div class="comp-item">
                  <div class="comp-dot" [style.background]="t.color"></div>
                  <div class="comp-label">{{ t.label }}</div>
                  <div class="comp-val">{{ t.count }}</div>
                  <div class="progress flex-grow-1" style="height:6px;"><div class="progress-bar" [style.background]="t.color" [style.width]="(dash_stats().total ? t.count/dash_stats().total*100 : 0)+'%'"></div></div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="hr-card">
          <div class="hcard-hdr warn-hdr"><i class="bi bi-calendar-event-fill me-2"></i>Leave Summary (Pending Requests)</div>
          <div class="hcard-body p-0">
            @for (l of leave_apps().filter(la=>la.status==='pending').slice(0,5); track l.id) {
              <div class="pending-leave-row">
                <div class="plr-av" [style.background]="'#1a3a6b'">{{ get_initials(l.emp_name) }}</div>
                <div class="plr-info"><div class="plr-name">{{ l.emp_name }}</div><div class="plr-dept">{{ l.department }} · {{ l.leave_type | titlecase }} · {{ l.days }} day(s)</div></div>
                <div class="plr-date text-muted small">{{ fmt_date(l.from_date) }}</div>
                <div class="plr-actions">
                  <button class="act-btn approve" (click)="approve_leave(l.id)" title="Approve"><i class="bi bi-check-lg"></i></button>
                  <button class="act-btn reject"  (click)="open_reject(l.id)"  title="Reject"><i class="bi bi-x-lg"></i></button>
                </div>
              </div>
            }
            @if (!leave_apps().find(la=>la.status==='pending')) { <div class="p-4 text-center text-muted small"><i class="bi bi-check2-circle me-2 text-success"></i>No pending leave requests.</div> }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ════════════ EMPLOYEES ══════════════════════════════════ -->
  @if (active_tab() === 'employees') {
    <div class="hr-card mb-3"><div class="hcard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label small fw-semibold text-muted">Search</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" name="emp_search" placeholder="Name, Emp ID, designation, phone…"
              [ngModel]="emp_search()" (ngModelChange)="emp_search.set($event)">
            @if (emp_search()) { <button type="button" class="btn btn-outline-secondary" (click)="emp_search.set('')"><i class="bi bi-x"></i></button> }
          </div>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Department</label>
          <select class="form-select" name="emp_dept_f" [ngModel]="emp_dept_f()" (ngModelChange)="emp_dept_f.set($event)">
            <option value="">All Depts</option>
            @for (d of unique_depts(); track d) { <option [value]="d.code">{{ d.name }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Staff Type</label>
          <select class="form-select" name="emp_staff_f" [ngModel]="emp_staff_f()" (ngModelChange)="emp_staff_f.set($event)">
            <option value="">All Types</option>
            @for (t of staff_type_opts; track t) { <option [value]="t">{{ t }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Status</label>
          <select class="form-select" name="emp_status_f" [ngModel]="emp_status_f()" (ngModelChange)="emp_status_f.set($event)">
            <option value="">All Status</option>
            @for (s of emp_status_opts; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Employment</label>
          <select class="form-select" name="emp_type_f" [ngModel]="emp_type_f()" (ngModelChange)="emp_type_f.set($event)">
            <option value="">All</option>
            @for (t of emp_type_opts; track t) { <option [value]="t">{{ t }}</option> }
          </select>
        </div>
        <div class="col-auto"><button type="button" class="btn btn-outline-secondary" (click)="reset_emp_filters()"><i class="bi bi-arrow-counterclockwise"></i></button></div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filtered_employees().length }} employee(s)</small>
    </div></div>

    <div class="hr-card">
      <div class="hcard-body p-0">
        @if (filtered_employees().length === 0) { <div class="empty-st"><i class="bi bi-person-x"></i><p>No employees found.</p></div>
        } @else {
          <div class="table-responsive">
            <table class="hr-table">
              <thead><tr><th>Emp ID</th><th>Name</th><th>Designation</th><th>Department</th><th>Type</th><th>Employment</th><th class="text-end">Salary</th><th>DOJ</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                @for (e of filtered_employees(); track e.id) {
                  <tr>
                    <td class="font-mono fw-semibold text-primary small">{{ e.emp_code }}</td>
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <div class="tiny-av" [style.background]="get_st_color(e.staff_type)">{{ get_initials(get_full_name(e)) }}</div>
                        <div><div class="small fw-semibold">{{ get_full_name(e) }}</div><div class="tiny-meta">{{ e.email }}</div></div>
                      </div>
                    </td>
                    <td class="small">{{ dataService.getDesiName(e.designation) }}</td>
                    <td class="small text-muted">{{ dataService.getDeptName(e.department) }}</td>
                    <td><span class="type-chip" [style.background]="get_st_bg(e.staff_type)" [style.color]="get_st_color(e.staff_type)">{{ e.staff_type }}</span></td>
                    <td class="small text-muted">{{ e.employment }}</td>
                    <td class="text-end small fw-semibold">{{ fmt_curr(e.basic_salary) }}</td>
                    <td class="small text-muted">{{ fmt_date(e.doj) }}<br><span class="tiny-meta">{{ calc_yoe(e.doj) }}</span></td>
                    <td><span class="{{ get_emp_st_class(e.status) }}">{{ e.status }}</span></td>
                    <td>
                      <div class="d-flex gap-1">
                        <button class="act-btn view"  (click)="view_employee(e)"  title="View"><i class="bi bi-eye-fill"></i></button>
                        <!-- <button class="act-btn edit"  (click)="open_emp_form(e)" title="Edit"><i class="bi bi-pencil-fill"></i></button> -->
                        @if (e.status !== 'Terminated') { <button class="act-btn del" (click)="terminate_employee(e.id)" title="Terminate"><i class="bi bi-person-x-fill"></i></button> }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  }

  <!-- ════════════ LEAVES ═════════════════════════════════════ -->
  @if (active_tab() === 'leaves') {
    <!-- Stats + Sub-tab -->
    <div class="d-flex align-items-center gap-3 mb-3 flex-wrap">
      <div class="leave-stat-chip warn"><i class="bi bi-hourglass-split me-1"></i>{{ leave_counts().pending }} Pending</div>
      <div class="leave-stat-chip ok"><i class="bi bi-check-circle-fill me-1"></i>{{ leave_counts().approved }} Approved</div>
      <div class="leave-stat-chip err"><i class="bi bi-x-circle-fill me-1"></i>{{ leave_counts().rejected }} Rejected</div>
      <div class="ms-auto d-flex gap-1">
        <button class="lsub-btn" [class.active]="leaves_sub()==='applications'" (click)="leaves_sub.set('applications')"><i class="bi bi-list-check me-1"></i>Applications</button>
        <button class="lsub-btn" [class.active]="leaves_sub()==='balance'"      (click)="leaves_sub.set('balance')"><i class="bi bi-bar-chart-fill me-1"></i>Leave Balance</button>
      </div>
    </div>

    @if (leaves_sub() === 'applications') {
      <div class="hr-card mb-3"><div class="hcard-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <div class="input-group">
              <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
              <input class="form-control border-start-0" name="leave_search" placeholder="Name, department, reason…"
                [ngModel]="leave_search()" (ngModelChange)="leave_search.set($event)">
            </div>
          </div>
          <div class="col-md-2">
            <select class="form-select" name="leave_status_f" [ngModel]="leave_status_f()" (ngModelChange)="leave_status_f.set($event)">
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <div class="col-md-2">
            <select class="form-select" name="leave_type_f" [ngModel]="leave_type_f()" (ngModelChange)="leave_type_f.set($event)">
              <option value="">All Types</option>
              @for (t of leave_type_opts; track t) { <option [value]="t">{{ t.charAt(0).toUpperCase()+t.slice(1) }}</option> }
            </select>
          </div>
          <div class="col-auto"><button type="button" class="btn btn-outline-secondary" (click)="reset_leave_filters()"><i class="bi bi-arrow-counterclockwise"></i></button></div>
        </div>
        <small class="text-muted mt-2 d-block">{{ filtered_leaves().length }} application(s)</small>
      </div></div>

      @if (filtered_leaves().length === 0) { <div class="empty-st"><i class="bi bi-calendar-x"></i><p>No leave applications found.</p></div>
      } @else {
        <div class="leave-list">
          @for (l of filtered_leaves(); track l.id) {
            <div class="leave-card" [class.lc-pending]="l.status==='pending'">
              <div class="lc-icon"><i class="bi {{ get_leave_type_icon(l.leave_type) }}"></i></div>
              <div class="lc-main">
                <div class="lc-row1">
                  <span class="lc-type text-capitalize">{{ l.leave_type }} Leave</span>
                  <span class="{{ get_leave_st_class(l.status) }}">{{ l.status }}</span>
                  <span class="lc-days text-muted small ms-auto">{{ l.days }} day(s)</span>
                </div>
                <div class="lc-name">
                  <span class="fw-semibold">{{ l.emp_name }}</span>
                  <span class="font-mono text-muted small">({{ l.emp_code }})</span> - 
                  <span class="fw-semibold">{{ dataService.getDeptName(l.department) }}</span> Dept.
                </div>
                <div class="lc-reason text-muted small">{{ l.reason }}</div>
                <div class="lc-meta">
                  <span><i class="bi bi-calendar3 me-1"></i>{{ fmt_date(l.from_date) }}{{ l.from_date!==l.to_date?' – '+fmt_date(l.to_date):'' }}</span>
                  <span class="ms-2 text-muted small">Applied: {{ fmt_date(l.applied_date) }}</span>
                  @if (l.approved_by) { <span class="ms-2 text-muted small">By: {{ l.approved_by }}</span> }
                  @if (l.remarks) { <span class="ms-2 text-danger small"><i class="bi bi-chat-text me-1"></i>{{ l.remarks }}</span> }
                </div>
              </div>
              @if (l.status === 'pending') {
                <div class="lc-actions">
                  <button class="act-btn approve" (click)="approve_leave(l.id)" title="Approve"><i class="bi bi-check-circle-fill me-1"></i></button>
                  <button class="act-btn reject"  (click)="open_reject(l.id)"  title="Reject"><i class="bi bi-x-circle-fill me-1"></i></button>
                </div>
              }
            </div>
          }
        </div>
      }
    }

    @if (leaves_sub() === 'balance') {
      <div class="hr-card">
        <div class="hcard-hdr"><i class="bi bi-bar-chart-fill me-2"></i>Leave Balance – All Employees</div>
        <div class="hcard-body p-0">
          <table class="hr-table">
            <thead><tr>
              <th>Emp ID</th><th>Employee</th><th>Department</th>
              <th class="text-center">Casual ({{ 'Used/Total' }})</th>
              <th class="text-center">Sick ({{ 'Used/Total' }})</th>
              <th class="text-center">Earned ({{ 'Used/Total' }})</th>
            </tr></thead>
            <tbody>
              @for (b of leave_bals(); track b.emp_code) {
                <tr>
                  <td class="font-mono small text-primary">{{ b.emp_code }}</td>
                  <td class="small fw-semibold">{{ b.emp_name }}</td>
                  <td class="small text-muted">{{ b.department }}</td>
                  <td class="text-center">
                    <div class="lb-row"><span class="lb-used">{{ b.casual_used }}</span><span class="lb-sep">/</span><span class="text-muted">{{ b.casual_total }}</span></div>
                    <div class="progress" style="height:4px;"><div class="progress-bar bg-warning" [style.width]="(b.casual_used/b.casual_total*100)+'%'"></div></div>
                  </td>
                  <td class="text-center">
                    <div class="lb-row"><span class="lb-used">{{ b.sick_used }}</span><span class="lb-sep">/</span><span class="text-muted">{{ b.sick_total }}</span></div>
                    <div class="progress" style="height:4px;"><div class="progress-bar bg-danger" [style.width]="(b.sick_used/b.sick_total*100)+'%'"></div></div>
                  </td>
                  <td class="text-center">
                    <div class="lb-row"><span class="lb-used">{{ b.earned_used }}</span><span class="lb-sep">/</span><span class="text-muted">{{ b.earned_total }}</span></div>
                    <div class="progress" style="height:4px;"><div class="progress-bar bg-primary" [style.width]="(b.earned_used/b.earned_total*100)+'%'"></div></div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  }

  <!-- ════════════ ATTENDANCE ═════════════════════════════════ -->
  @if (active_tab() === 'attendance') {
    <!-- Date + Dept filter -->
    <div class="hr-card mb-3"><div class="hcard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-semibold">Date</label>
          <input type="date" class="form-control" name="att_date" [ngModel]="att_date()" (ngModelChange)="att_date.set($event)">
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Search</label>
          <input class="form-control" name="att_search" placeholder="Name or Emp ID…"
            [ngModel]="att_search()" (ngModelChange)="att_search.set($event)">
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Department</label>
          <select class="form-select" name="att_dept_f" [ngModel]="att_dept_f()" (ngModelChange)="att_dept_f.set($event)">
            <option value="">All Departments</option>
            @for (d of unique_depts(); track d) { <option [value]="d.code">{{ d.name }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Status</label>
          <select class="form-select" name="att_status_f" [ngModel]="att_status_f()" (ngModelChange)="att_status_f.set($event)">
            <option value="">All</option>
            @for (s of att_status_opts; track s) { <option [value]="s">{{ s.replace('_',' ') }}</option> }
          </select>
        </div>
        <div class="col-auto"><button type="button" class="btn btn-outline-secondary mt-4" (click)="reset_att_filters()"><i class="bi bi-arrow-counterclockwise"></i></button></div>
      </div>
    </div></div>
    <!-- Summary -->
    <div class="att-summary-row mb-3">
      @for (s of [{k:'present',l:'Present',c:'#059669'},{k:'absent',l:'Absent',c:'#dc2626'},{k:'late',l:'Late',c:'#f59e0b'},{k:'half_day',l:'Half Day',c:'#7c3aed'},{k:'on_leave',l:'On Leave',c:'#0891b2'},{k:'holiday',l:'Holiday',c:'#374151'}]; track s.k) {
        <div class="att-chip" [style.border-color]="s.c" [style.background]="s.c+'18'">
          <div class="att-chip-val" [style.color]="s.c">{{ s.k==='present'?att_summary().present:s.k==='absent'?att_summary().absent:s.k==='late'?att_summary().late:s.k==='half_day'?att_summary().half_day:s.k==='on_leave'?att_summary().on_leave:att_summary().holiday }}</div>
          <div class="att-chip-lbl">{{ s.l }}</div>
        </div>
      }
    </div>
    <div class="hr-card"><div class="hcard-body p-0">
      @if (filtered_att().length === 0) {
        <div class="empty-st"><i class="bi bi-person-x"></i><p>No employees to mark for this date.</p></div>
      } @else {
        <div class="table-responsive">
          <table class="hr-table">
            <thead><tr><th>Emp ID</th><th>Name</th><th>Department</th><th class="text-center">In Time</th><th class="text-center">Out Time</th><th class="text-center">Hours</th><th>Status</th><th>Mark</th></tr></thead>
            <tbody>
              @for (a of filtered_att(); track a.emp_code + a.date) {
                <tr>
                  <td class="font-mono small text-primary">{{ a.emp_code }}</td>
                  <td class="small fw-semibold">{{ a.emp_name }}</td>
                  <td class="small text-muted">{{ dataService.getDeptName(a.department) }}</td>
                  <td class="text-center">
                    <input type="time" class="form-control form-control-sm att-time-input"
                      [class.text-warning]="a.check_in && a.check_in > '09:00'"
                      [ngModel]="a.check_in" (ngModelChange)="set_att_check_in(a, $event)"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="a.id > 0 && att_times_disabled(a.status)">
                  </td>
                  <td class="text-center">
                    <input type="time" class="form-control form-control-sm att-time-input"
                      [ngModel]="a.check_out" (ngModelChange)="set_att_check_out(a, $event)"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="a.id > 0 && att_times_disabled(a.status)">
                  </td>
                  <td class="text-center small fw-semibold">{{ fmt_hours(a.working_hours) }}</td>
                  <td>
                    @if (a.id > 0) {
                      <span class="{{ get_att_st_class(a.status) }}">
                        <i class="bi {{ get_att_icon(a.status) }} me-1"></i>{{ a.status.replace('_',' ') }}
                      </span>
                    } @else {
                      <span class="text-muted small">Not marked</span>
                    }
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <select class="form-select form-select-sm" style="width:120px;"
                        [ngModel]="a.id ? a.status : ''" (ngModelChange)="mark_att(a.emp_code, $event)" [ngModelOptions]="{standalone: true}">
                        @if (!a.id) { <option value="">Mark…</option> }
                        @for (s of att_status_opts; track s) { <option [value]="s">{{ s.replace('_',' ') }}</option> }
                      </select>
                      <button type="button" class="act-btn view" title="Enter in/out time" (click)="open_att_form(a)"><i class="bi bi-clock-fill"></i></button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div></div>
  }

  <!-- ════════════ PAYROLL ════════════════════════════════════ -->
  @if (active_tab() === 'payroll') {
    <div class="hr-card mb-3"><div class="hcard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-2">
          <label class="form-label fw-semibold">Month</label>
          <input type="month" class="form-control" name="pay_month" [ngModel]="pay_month()" (ngModelChange)="pay_month.set($event)">
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Search</label>
          <input class="form-control" name="pay_search" placeholder="Name or Emp ID…"
            [ngModel]="pay_search()" (ngModelChange)="pay_search.set($event)">
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Department</label>
          <select class="form-select" name="pay_dept_f" [ngModel]="pay_dept_f()" (ngModelChange)="pay_dept_f.set($event)">
            <option value="">All Departments</option>
            @for (d of unique_depts(); track d) { <option [value]="d.code">{{ d.name }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Status</label>
          <select class="form-select" name="pay_status_f" [ngModel]="pay_status_f()" (ngModelChange)="pay_status_f.set($event)">
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="processed">Processed</option>
            <option value="paid">Paid</option>
          </select>
        </div>
        @if (pay_summary().pending == 0) {
        <div class="col-md-2 d-flex justify-content-end">
          <button class="btn hr-btn-primary btn-sm" (click)="generate_payroll()">
            <i class="bi bi-currency-rupee"></i> Gen. Payroll</button>
        </div>
        }
        @if (pay_summary().pending > 0) {
          <div class="col-md-2 d-flex justify-content-end">
            <button class="btn btn-outline-success" (click)="mark_all_paid()"><i class="bi bi-check2-all me-1"></i>Mark All Paid</button>
          </div>
        }
      </div>
    </div></div>
    <!-- Summary Cards -->
    <div class="pay-summary-row mb-3">
      <div class="pay-chip pay-gross"><div class="py-val">{{ fmt_short(pay_summary().gross) }}</div><div class="py-lbl">Gross Payroll</div></div>
      <div class="pay-chip pay-net"><div class="py-val">{{ fmt_short(pay_summary().net) }}</div><div class="py-lbl">Net Payroll</div></div>
      <div class="pay-chip pay-pf"><div class="py-val">{{ fmt_short(pay_summary().pf) }}</div><div class="py-lbl">Total PF</div></div>
      <div class="pay-chip pay-tds"><div class="py-val">{{ fmt_short(pay_summary().tds) }}</div><div class="py-lbl">Total TDS</div></div>
      <div class="pay-chip pay-paid"><div class="py-val text-success">{{ pay_summary().paid }}</div><div class="py-lbl">Paid</div></div>
      <div class="pay-chip pay-pending"><div class="py-val text-warning">{{ pay_summary().pending }}</div><div class="py-lbl">Pending</div></div>
    </div>
    @if (filtered_payroll().length === 0) {
      <div class="empty-st"><i class="bi bi-cash-stack"></i><p>No payroll records. Click "Generate Payroll" to create.</p></div>
    } @else {
      <div class="hr-card"><div class="hcard-body p-0">
        <table class="hr-table">
          <thead><tr><th>Emp ID</th><th>Name</th><th>Department</th><th class="text-end">Gross</th><th class="text-end">PF</th><th class="text-end">TDS</th><th class="text-end">Net</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            @for (p of filtered_payroll(); track p.id) {
              <tr>
                <td class="font-mono small text-primary">{{ p.emp_code }}</td>
                <td class="small fw-semibold">{{ p.emp_name }}</td>
                <td class="small text-muted">{{ dataService.getDeptName(p.department) }}</td>
                <td class="text-end small">{{ fmt_curr(p.gross_salary) }}</td>
                <td class="text-end small text-danger">{{ fmt_curr(p.pf_deduction) }}</td>
                <td class="text-end small text-danger">{{ fmt_curr(p.tds_deduction) }}</td>
                <td class="text-end small fw-bold text-success">{{ fmt_curr(p.net_salary) }}</td>
                <td><span class="{{ get_pay_st_class(p.status) }}">{{ p.status }}</span></td>
                <td>
                  <div class="d-flex gap-1">
                    <button class="act-btn view" (click)="open_payslip(p)" title="View Payslip"><i class="bi bi-file-earmark-text-fill"></i></button>
                    @if (p.status !== 'paid') { <button class="act-btn approve" (click)="mark_paid(p.id)" title="Mark Paid"><i class="bi bi-check-lg"></i></button> }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div></div>
    }
  }

  <!-- ════════════ RECRUITMENT ════════════════════════════════ -->
  @if (active_tab() === 'recruitment') {
    <div class="row g-4">
      <!-- Job Openings -->
      <div class="col-lg-5">
        <div class="hr-card mb-3"><div class="hcard-body">
          <div class="d-flex gap-2 align-items-center flex-wrap">
            <input class="form-control form-select-sm" style="max-width:200px;" name="rec_search" placeholder="Search jobs…"
              [ngModel]="rec_search()" (ngModelChange)="rec_search.set($event)">
            <select class="form-select form-select-sm" style="max-width:140px;" name="rec_status_f"
              [ngModel]="rec_status_f()" (ngModelChange)="rec_status_f.set($event)">
              <option value="">All Status</option>
              <option value="open">Open</option>
              <option value="on_hold">On Hold</option>
              <option value="closed">Closed</option>
            </select>
            <span class="text-muted small">{{ filtered_jobs().length }} opening(s)</span>
          </div>
        </div></div>
        @for (j of filtered_jobs(); track j.id) {
          <div class="job-card mb-2" [class.job-selected]="selected_job()?.id===j.id" (click)="selected_job.set(j)">
            <div class="jc-top"><span class="jc-code font-mono">{{ j.job_code }}</span><span class="{{ get_job_st_class(j.status) }}">{{ j.status.replace('_',' ') }}</span></div>
            <div class="jc-title">{{ j.title }}</div>
            <div class="jc-dept text-muted small"><i class="bi bi-building me-1"></i>{{ j.department }}</div>
            <div class="jc-meta">
              <span><i class="bi bi-people me-1"></i>{{ j.filled }}/{{ j.positions }} filled</span>
              <span class="ms-2"><i class="bi bi-clock me-1"></i>{{ job_type_labels[j.emp_type] }}</span>
              <span class="ms-2"><i class="bi bi-calendar3 me-1"></i>Closes: {{ fmt_date(j.closing_date) }}</span>
            </div>
            @if (j.description) { <div class="jc-desc text-muted small">{{ j.description }}</div> }
            <div class="jc-actions" (click)="$event.stopPropagation()">
              <select class="form-select form-select-sm jc-status" title="Change status"
                [ngModel]="j.status" (ngModelChange)="change_job_status(j, $event)" [ngModelOptions]="{standalone: true}">
                @for (s of job_status_opts; track s) { <option [value]="s">{{ job_status_labels[s] }}</option> }
              </select>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="view_job(j, $event)"><i class="bi bi-eye-fill me-1"></i>View</button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="open_job_form(j, $event)"><i class="bi bi-pencil-fill me-1"></i>Edit</button>
              <!-- <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copy_job_link(j, $event)"><i class="bi bi-link-45deg me-1"></i>Copy link</button> -->
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete_job(j, $event)"><i class="bi bi-trash-fill me-1"></i>Delete</button>
            </div>
          </div>
        }
        @if (filtered_jobs().length === 0) { <div class="empty-st"><i class="bi bi-briefcase"></i><p>No job openings.</p></div> }
      </div>
      <!-- Applications -->
      <div class="col-lg-7">
        @if (!selected_job()) {
          <div class="empty-st mt-5"><i class="bi bi-arrow-left-circle"></i><p>Select a job opening to view applications.</p></div>
        } @else {
          @let sj = selected_job()!;
          <div class="hr-card mb-3">
            <div class="hcard-hdr d-flex align-items-center gap-2 flex-wrap">
              <i class="bi bi-people-fill me-1"></i>
              <span class="flex-grow-1">{{ sj.title }} — Applications ({{ apps_for_job().length }})</span>
              <button type="button" class="btn btn-sm btn-light" (click)="view_job(sj)"><i class="bi bi-eye-fill me-1"></i>View details</button>
              <!-- <button type="button" class="btn btn-sm btn-outline-light" (click)="copy_job_link(sj)"><i class="bi bi-link-45deg me-1"></i>Copy link</button> -->
            </div>
            <div class="hcard-body">
              <div class="app-pipeline-row">
                @for (s of [{k:'applied',l:'Applied',c:'#6b7280'},{k:'shortlisted',l:'Shortlisted',c:'#d97706'},{k:'interviewed',l:'Interviewed',c:'#2563eb'},{k:'selected',l:'Selected',c:'#059669'},{k:'rejected',l:'Rejected',c:'#dc2626'}]; track s.k) {
                  <div class="app-pipe-step" [style.border-color]="s.c">
                    <div class="aps-val" [style.color]="s.c">{{ s.k==='applied'?app_pipeline().applied:s.k==='shortlisted'?app_pipeline().shortlisted:s.k==='interviewed'?app_pipeline().interviewed:s.k==='selected'?app_pipeline().selected:app_pipeline().rejected }}</div>
                    <div class="aps-lbl">{{ s.l }}</div>
                  </div>
                }
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <div class="input-group mt-2" style="max-width:320px;">
                  <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
                  <input class="form-control border-start-0" name="app_search" placeholder="Search applicants…" [ngModel]="app_search()" (ngModelChange)="app_search.set($event)">
                </div>
                <!-- <button class="btn btn-sm btn-link" (click)="open_public_job(sj)"><i class="bi bi-box-arrow-up-right me-1"></i>Open candidate view</button> -->
                 <a href="/careers/{{sj.job_code}}" class="ms-auto" target="_blank"><i class="bi bi-box-arrow-up-right me-1"></i>Open candidate view</a>
              </div>
            </div>
          </div>
          <div class="app-list">
            @for (a of apps_for_job(); track a.id) {
              <div class="app-card">
                <div class="appc-av">{{ get_initials(a.applicant_name) }}</div>
                <div class="appc-info">
                  <div class="appc-name">{{ a.applicant_name }}</div>
                  <div class="appc-meta small text-muted">{{ a.email }} · {{ a.phone }} · {{ a.experience }} yr(s) exp</div>
                  <div class="appc-date text-muted" style="font-size:.68rem;">Applied: {{ fmt_date(a.applied_date) }}</div>
                  @if (a.remarks) { <div class="appc-rem text-muted" style="font-size:.68rem;"><i class="bi bi-chat-text me-1"></i>{{ a.remarks }}</div> }
                </div>
                <div class="appc-right">
                  <span class="{{ get_app_st_class(a.status) }}">{{ a.status }}</span>
                  <div class="appc-actions mt-1">
                    @if (a.status === 'applied')      { <button class="act-btn approve" (click)="shortlist_app(a.id)" title="Shortlist"><i class="bi bi-bookmark-fill"></i></button> }
                    @if (a.status === 'shortlisted')  { <button class="act-btn send"    (click)="interview_app(a.id)" title="Move to Interview"><i class="bi bi-camera-video-fill"></i></button> }
                    @if (a.status === 'interviewed')  { <button class="act-btn approve" (click)="select_app(a.id)"    title="Select"><i class="bi bi-check-circle-fill"></i></button> }
                    @if (!['selected','rejected'].includes(a.status)) { <button class="act-btn del" (click)="reject_app(a.id)" title="Reject"><i class="bi bi-x-circle-fill"></i></button> }
                  </div>
                </div>
              </div>
            }
            @if (apps_for_job().length === 0) { <div class="empty-st p-5"><i class="bi bi-inbox"></i><p>No applications yet.</p></div> }
          </div>
        }
      </div>
    </div>
  }

</div>
